import { createAction } from 'services/actionConfigs';
import { createAsyncAction } from 'store/actionConfigs';
import { ICategoryResItem, IServiceResItem, IStaffResItem } from 'types/response';
import { IAptSuccessData } from './types/appointment';

const PREFIX_ACTIONS = 'appointment_feature_';

const aptActions = {
  detail: createAsyncAction<string>(PREFIX_ACTIONS + 'getAppointmentDetail'),
  setSuccessData: createAction<IAptSuccessData>(PREFIX_ACTIONS + 'setSuccessData'),
  getTransactionDetail: createAsyncAction<string>(PREFIX_ACTIONS + 'getTransactionDetail'),
  initCustomerId: createAction<string>(PREFIX_ACTIONS + 'initCustomerId'),
  services: createAsyncAction<number | undefined, IServiceResItem[]>(PREFIX_ACTIONS + 'services'),
  category: createAction<ICategoryResItem[]>(PREFIX_ACTIONS + 'category'),

  bookingV3Init: createAsyncAction<string, undefined, undefined>(PREFIX_ACTIONS + 'bookingV3Init'),
  bookingV3GetStaffsAvailableByDate: createAsyncAction<string, IStaffResItem[]>(PREFIX_ACTIONS + 'bookingV3GetStaffsAvailableByDate'),
  bookingV3GetCategories: createAsyncAction<string, ICategoryResItem[]>(PREFIX_ACTIONS + 'bookingV3GetCategories'),
  bookingv3GetAvailableTimeSlotByStaffAndDate: createAsyncAction<{ staffId: string, currentDate: string }, string[]>(PREFIX_ACTIONS + 'bookingv3GetAvailableTimeSlotByStaffAndDate'),
};

export default aptActions;

